import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Tsunami freeze",
  "description": "",
  "published": "2007-01-31T00:00:00.000Z",
  "redirect_from": ["/blog/tsunami-freeze/swizec/299"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Even though `}<a parentName="p" {...{
        "href": "http://www.harkvideos.com/arctic.htm"
      }}>{`this`}</a>{` isn't and couldn't be a frozen tsunami, it still looks very interesting and is lovely to look at.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      